import MuiToggleButtonGroup, {
  type ToggleButtonGroupProps as MuiToggleButtonGroupProps,
} from '@mui/material/ToggleButtonGroup';
import { form } from '@/shared/theme';
import { mergeSx } from '../utils/mergeSx';

export type ToggleButtonGroupProps = MuiToggleButtonGroupProps;

/**
 * Shared exclusive/multi toggle group.
 * Single 1px outline + 1px dividers between buttons (no stacked borders).
 */
const ToggleButtonGroup = ({
  size = 'small',
  sx,
  ...props
}: ToggleButtonGroupProps) => (
  <MuiToggleButtonGroup
    size={size}
    sx={mergeSx(
      {
        bgcolor: 'common.white',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        overflow: 'hidden',
        ...(size === 'small' ? { height: form.controlHeight } : {}),
        '& .MuiToggleButtonGroup-grouped': {
          margin: 0,
          border: 0,
          borderRadius: 0,
          borderColor: 'transparent',
          '&:not(:first-of-type)': {
            marginLeft: 0,
            borderLeft: '1px solid',
            borderLeftColor: 'divider',
          },
          '&.Mui-selected + .MuiToggleButtonGroup-grouped': {
            borderLeft: '1px solid',
            borderLeftColor: 'divider',
          },
        },
        '& .MuiToggleButton-root': {
          textTransform: 'none',
          bgcolor: 'common.white',
          color: 'text.primary',
          border: 0,
          borderRadius: 0,
          ...(size === 'small'
            ? {
                height: form.controlHeight,
                minHeight: form.controlHeight,
                py: 0,
                lineHeight: 1.25,
              }
            : {}),
          '&:hover': {
            bgcolor: 'action.hover',
          },
          '&.Mui-selected': {
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            '&:hover': {
              bgcolor: 'primary.dark',
              color: 'primary.contrastText',
            },
          },
        },
      },
      sx
    )}
    {...props}
  />
);

export default ToggleButtonGroup;
